import { requestFromServer } from "./api-client";

const Products = {
  list: async (onlyAvailable, idLoadType) => {
    return requestFromServer(`v1/Products/list/${onlyAvailable}/${idLoadType}`);
  },
  listByPlant: async (idLoadType, idPlant) => {
    return requestFromServer(
      `v1/Products/listByPlantId/${idLoadType}/${idPlant}`
    );
  },
};

export default Products;
